import React from "react";
import _ from "lodash";
import { makeStyles } from "@material-ui/core";
import { StepperProgress } from "./StepperProgress";
import { StepperHeading } from "./StepperHeading";
import { useSelector } from "react-redux";
import { MOBILE_PAGES } from "../pageMobile";
import { labels } from "../Stepper";

const useStyles = makeStyles(
  () => ({
    root: {
      display: "flex",
      flexWrap: "nowrap",
      flexGrow: 0,
      width: "100%",
      backgroundColor: "#ffffff"
    }
  }),
  {
    name: "StepperHeader"
  }
);

export function StepperHeader() {
  const classes = useStyles();
  const currentPage = useSelector((state) => state.pageNumber);
  const mobilePageCount = React.useMemo(() => _.size(MOBILE_PAGES), []);
  return (
    <div className={classes.root}>
      <StepperProgress
        label={`${currentPage}/${_.size(MOBILE_PAGES)}`}
        progress={(currentPage / mobilePageCount) * 100}
      />
      <StepperHeading
        stepHeading={labels[currentPage - 1][0]}
        nextStepHeading={labels[currentPage]?.[0]}
        currentPage={currentPage}
      />
    </div>
  );
}
